export default __webpack_public_path__ + "static-front/media/Arrow.ab58ec31.svg";